import MoistureSensorMarkerIcon from "../../../features/map-markers/moisture-sensor-marker-icon";
import DraginoGatewayIcon from "../../../icons/inline-react-svgs/add-device/dragino-gateway-icon";
import { isThirdPartyGateway } from "../../device-attributes/configurations";
import DeviceMapEntity from "./device-map-entity";

export class ThirdPartyDeviceMapEntity extends DeviceMapEntity {
    status = "Unknown";

    pickIcon() {
        if (isThirdPartyGateway(this.model.deviceType)) {
            this.icon = DraginoGatewayIcon;
        } else {
            this.icon = MoistureSensorMarkerIcon;
        }
    }
}
